/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareCutIcon64Regular = forwardRef('CheckSquareCutIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M10 17.5a7.5 7.5 0 0 1 7.5-7.5h22a1.5 1.5 0 0 0 0-3h-22C11.701 7 7 11.701 7 17.5v29C7 52.299 11.701 57 17.5 57h29C52.299 57 57 52.299 57 46.5v-12a1.5 1.5 0 0 0-3 0v12a7.5 7.5 0 0 1-7.5 7.5h-29a7.5 7.5 0 0 1-7.5-7.5v-29Z" }),
        React.createElement("path", { d: "M56.56 15.56a1.5 1.5 0 0 0-2.12-2.12L32.974 34.903a3.5 3.5 0 0 1-4.95 0l-7.964-7.965a1.5 1.5 0 0 0-2.122 2.122l7.965 7.964a6.5 6.5 0 0 0 9.192 0l21.465-21.464Z" })));
});
